import * as React from "react";
import { withStyles , WithStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Button,
  TableHead
} from "@material-ui/core";
import { AddBox as AddIcon } from "@material-ui/icons";
import EditableListItem from "./EditableListItem";
import { RouteComponentProps } from "react-router-dom";

const styles = (theme: any) => ({
  addIcon: {
    marginLeft: theme.spacing.unit * 2,
  },
});

interface IEditableListHeader {
  key: string,
  value: string
}

interface IEditabeListProps {
  addLabel: string,
  editable: boolean,
  directlyEditable: boolean,
  headers: IEditableListHeader[],
  items: any[],
  newItem: any,
  onChange: any,
  settings: any
}

interface IProps extends WithStyles<typeof styles>, RouteComponentProps<IEditabeListProps>, IEditabeListProps {
}

class EditableList extends React.Component<IProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      items: this.props.items ? this.props.items : [],
      lastItemIsNew: false,
    };
  }

  public propChangeHandler(name: string, value: any, itemIndex: number) {
    const { items } = this.state;
    const itemsActual = [
      ...items.slice(0, itemIndex),
      {
        ...items[itemIndex],
        [name]: value,
      },
      ...items.slice(itemIndex + 1),
    ];
    this.setState({ items: itemsActual });
    this.props.onChange(itemsActual);
  }

  public delete(index: number) {
    const items = [...this.state.items];
    items.splice(index, 1);
    this.setState({ items });
    this.props.onChange(items);
  }

  public add() {
    const items = [...this.state.items];
    const newItem = { ...this.props.newItem };
    items.push(newItem);
    this.setState({ items, lastItemIsNew: true });
    this.props.onChange(items);
  }

  public render() {
    const { editable, headers, classes, directlyEditable } = this.props;
    const { items } = this.state;
    return (
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header: any, index: number) => (
                  <TableCell key={index}>{header}</TableCell>
              ))}
              {editable && <TableCell/>}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item: any, index: number) => {
              return (
                  <EditableListItem
                      key={index}
                      item={item}
                      editable={editable}
                      directlyEditable={directlyEditable}
                      propChangeHandler={(name: string, value: any) =>
                          this.propChangeHandler(name, value, index)
                      }
                      deleteHandler={() => this.delete(index)}
                      settings={this.props.settings}
                      isNew={index === items.length - 1 && this.state.lastItemIsNew}
                  />
              );
            })}
            {editable && (
                <TableRow>
                  <TableCell colSpan={headers.length + 1}>
                    <Button color="primary" onClick={() => this.add()}>
                      {this.props.addLabel ? this.props.addLabel : "Add"}
                      <AddIcon className={classes.addIcon} fontSize="small" />
                    </Button>
                  </TableCell>
                </TableRow>
            )}
          </TableBody>
        </Table>
    );
  }
}

export default withStyles(styles)(EditableList);



// WEBPACK FOOTER //
// ./src/modules/shared/components/EditableList.tsx